import { Card, Row, Col, Spin } from 'antd';
import InvoiceStatsModal from './StatsModals/InvoiceStatsModal';
import { useState } from 'react';
import ReceiptStatsModal from './StatsModals/ReceiptStatsModal';
import GoCardLessStatsModal from './StatsModals/GoCardLessStatsModal';
import StripeStatsModal from './StatsModals/StripeStatsModal';
import IncommingStatsModal from './StatsModals/IncommingStatsModal';
import OutgoingStatsModal from './StatsModals/OutgoingStatsModal';
import EmailStatsModal from './StatsModals/EmailStatsModal';
import StorageStatsModal from './StatsModals/StorageStatsModal';
import { LoadingOutlined } from '@ant-design/icons';
interface cardProps {
  id: string;
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  hoverable?: boolean;
  extra?: React.ReactNode;
  loading?: boolean;
  fromDate:string,
  toDate:string
}

const HeaderCard = ({
  id,
  title,
  value,
  icon,
  hoverable = true,
  extra,
  loading = false,
  fromDate,
  toDate
}: cardProps) => {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const renderModal = () => {
    switch (activeModal) {
      case "incoming":
        return <IncommingStatsModal open onCancel={() => setActiveModal(null) }  fromDate={fromDate} toDate={toDate}/>;
      case "outgoing":
        return <OutgoingStatsModal open onCancel={() => setActiveModal(null) }  fromDate={fromDate} toDate={toDate}/>;
      case "emails":
        return <EmailStatsModal open onCancel={() => setActiveModal(null) }  fromDate={fromDate} toDate={toDate}/>;
      case "storageUses":
        return <StorageStatsModal open onCancel={() => setActiveModal(null) }  fromDate={fromDate} toDate={toDate}/>;
      case "invoice":
        return <InvoiceStatsModal open onCancel={() => setActiveModal(null) }  fromDate={fromDate} toDate={toDate}/>;
      case "receipts":
        return <ReceiptStatsModal open onCancel={() => setActiveModal(null)}  fromDate={fromDate} toDate={toDate}/>;
      case "stripe":
        return <StripeStatsModal open onCancel={() => setActiveModal(null)}  fromDate={fromDate} toDate={toDate}/>;
      case "goCardLess":
        return <GoCardLessStatsModal open onCancel={() => setActiveModal(null)}  fromDate={fromDate} toDate={toDate}/>;
      default:
        return null;
    }
  };

  return (
    <>
      <Card key={id}  hoverable={hoverable} extra={extra} style={{ lineHeight: 1.8 }} styles={{ body: { padding: "14px 0 10px 16px" } }} onClick={()=>setActiveModal(id)}>
        <Spin
            spinning={loading}
            indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
        >
          <Row align="middle" gutter={8}>
            {icon && <Col>{icon}</Col>}
            <Col style={{ fontSize: 14, color: 'rgba(0,0,0,0.45)' }}>
              {title}
            </Col>
          </Row>

          <Row className="fs15 fw600" style={{  color: 'rgba(0,0,0,0.85)', marginLeft: 6 }}>
            {value}
          </Row>
        </Spin>
      </Card>
      {renderModal()}
    </>
  );
};

export default HeaderCard;
